// @flow
import styled from 'styled-components';

export const Container = styled.div`
    height: 100%;
    position: relative;
    width: 100%;
`;



// WEBPACK FOOTER //
// ./src/components/dom/dom-resize/styles.js